import DOMPurify from 'dompurify'

import type { Config } from 'dompurify'

/**
 * Sanitize user-authored rich text (e.g. tiptap `getHTML()` output stored on
 * the API) before it is rendered with `v-html`. Keeps safe markup, strips
 * scripts and inline event handlers (DOMPurify defaults).
 *
 * Pass `config` to narrow the allow-list for a sink that only ever renders a
 * known subset of markup — the defaults still permit links, images and block
 * elements, which are XSS-safe but not always wanted.
 */
export function sanitizeHtml(source: string | null | undefined, config?: Config): string {
  if (!source) return ''
  return DOMPurify.sanitize(source, config)
}

/**
 * Clean HTML by removing empty paragraphs and trimming
 * Matches the logic from VisualTextEditor.cleanHtml
 * e.g: <p></p><div>test</div> → <div>test</div>
 */
export function cleanHtml(value: string | null | undefined): string {
  if (!value) return ''
  return value.replaceAll(/<p>\s*<\/p>/g, '').trim() // Remove empty paragraphs
}

/**
 * Extract plain text from HTML content
 * e.g: <p>test</p><div>example</div> → testexample
 */
export function getPlainText(html: string): string {
  return html.replace(/<[^>]*>/g, '').trim()
}
